module.exports = __webpack_public_path__ + "static/media/enquiries.84e46078.svg";